import React, { useState } from 'react'
import { Container, Content, TherapistsTitle, Form, FormGroup, Label, Description } from './styled';
import useI18n from 'hooks/useI18n';
import Check from 'components/Form/Check';
import Input from 'components/Form/Input';
import Button from 'components/Form/Button';
import { ButtonContainer, FormSpacer, Icon } from 'ui/styled';
import UploadFile from 'components/Form/UploadFile';
import { toast } from 'react-toastify';
import { Create } from 'services/core';
import { apiRequest, exposeStrapiError } from 'utils';
import { useHistory } from 'react-router-dom';

const UNIVERSE_SUPPORT = 'MagVenture Universe Support';
const PRODUCT_SUPPORT = 'Product & Service Support';

export default function ContactUs() {

  const history = useHistory();
  const { t } = useI18n()
  const [form, setForm] = useState({})
  const formValue = ref => { return form?.[ref] ? form?.[ref] : ''; }
  const changeForm = (value, ref) => { setForm({ ...form, [ref]: value }); }

  const [file, setFile] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState('');
  const [loading, setLoading] = useState(false)

  const handleTopicChange = (topic) => {
    setSelectedTopic(topic === selectedTopic ? '' : topic);
  };

  const [preferredContact, setPreferredContact] = useState([]);

  const handleContactChange = (method) => {

    setPreferredContact(prev => method === prev ? '' : method);

    // setPreferredContact(prev =>
    //   prev.includes(method) ? prev.filter(m => m !== method) : [...prev, method]
    // );
  };

  const valid = (verbose) => {
    if (!selectedTopic?.length) {
      if (verbose) { toast.error(`${t("contact.topicCategory.label")} ${t('contact.is_required')}`); }
      return false;
    }

    if (!form?.message?.length) {
      if (verbose) { toast.error(`${t("contact.message.label")} ${t('contact.is_required')}`); }
      return false;
    }

    if (!preferredContact?.length) {
      if (verbose) { toast.error(`${t("contact.preferredContact.label")} ${t('contact.is_required')}`); }
      return false;
    }

    return true;
  }

  const save = async () => {
    if (!valid(true)) return;
    setLoading(true)

    const payload = {
      topic: selectedTopic,
      message: form?.message,
      file: file?.id,
      contact_method: preferredContact,
    }

    const saved = await apiRequest(() => Create("contacts", { data: payload }))

    if (!exposeStrapiError(saved)) {
      toast.success(t("contact.success"))
      history.goBack()
    }

    setLoading(false)
  }

  return (
    <>
      <FormSpacer extraLarge />
      <Content>
        <TherapistsTitle>{t("contact")}</TherapistsTitle>
        <Container>
          <Form>
            <FormGroup>
              <Label>{t("contact.topicCategory.label")} (required)</Label>
              <Description>{t("contact.chooseSubject")}</Description>
              <Check
                label={UNIVERSE_SUPPORT}
                checked={selectedTopic === UNIVERSE_SUPPORT}
                onChange={() => handleTopicChange(UNIVERSE_SUPPORT)}
              />
              <Description>Questions about MagVenture Universe content, access, or functionality.</Description>
              <Check
                label={PRODUCT_SUPPORT}
                checked={selectedTopic === PRODUCT_SUPPORT}
                onChange={() => handleTopicChange(PRODUCT_SUPPORT)}
              />
              <Description>Questions about MagVenture products, product information, or service support.</Description>
            </FormGroup>

            <FormGroup>
              <Label>{t("contact.message.label")} (required)</Label>
              <Description>{t("contact.describeIssue")}</Description>
              <Input
                type="textarea"
                maxLength={1000}
                placeholder={t("contact.message")}
                value={formValue('message')} onChange={e => changeForm(e.target.value, 'message')}
              />
              <Description>{t("contact.maximum_characters")}</Description>
            </FormGroup>

            <FormGroup>
              <Label>{t("contact.fileAttachment.label")} (optional)</Label>
              <Description>{t("contact.attachmentHelp")}</Description>
              <UploadFile onChange={setFile}>
                <Button width={'fit-content'} color='info' startIcon={<Icon icon="upload" />}>{t("contact.file")}</Button>
              </UploadFile>
            </FormGroup>

            <FormGroup>
              <Label>{t("contact.preferredContact.label")} (required)</Label>
              <Description>{t("contact.contactPreference")}</Description>
              <Check label={t("contact.email.label")} checked={preferredContact.includes('email')} onChange={() => handleContactChange('email')} />
              <Check label={t("contact.phone.label")} checked={preferredContact.includes('phone')} onChange={() => handleContactChange('phone')} />
            </FormGroup>
          </Form>
          <ButtonContainer center>
            <Button width={'250px'} color='blue' onClick={save} loading={loading}>{t("contact.submit")}</Button>
          </ButtonContainer>
        </Container>
      </Content>
    </>

  )
}
